<template>
  <div class="landing-page">
    <div class="section section--first">
      <div class="description">
        <h1>DASH</h1>
        <h2>Your Dashboard for Autonomous System Health</h2>
        <p class="large">
          Rapidly track suspicious traffic seen coming from your network.
        </p>
        <p class="large font-weight-bold">
          NEW features:
        </p>
        <ul class="feature-text">
          <li>
            <p class="large">Alert system to detect suspicious traffic</p>
          </li>
          <li>
            <p class="large">Option to receive recurring reports</p>
          </li>
          <li>
            <p class="large">
              Review, detect, and be notified of your network's
              <br class="break-line" />BGP, RPKI, and IRR misalignments.
            </p>
          </li>
        </ul>
        <button class="btn btn-primary" @click="authenticateOidc">
          Log in
        </button>
      </div>
      <div class="row section-1">
        <div class="col-md-2 left"></div>
        <div class="col-md-10 right">
          <img v-lazy="'/static/landing/section1.svg'" alt="dashboard image" />
        </div>
      </div>
      <div class="discover-more" v-scroll-to="'#scroll-here'">
        Discover more
        <img
          v-lazy="'/static/landing/discover-more.png'"
          alt="discover-more image"
        />
      </div>
    </div>

    <div class="section" id="scroll-here">
      <div class="container py-4">
        <div class="row">
          <div class="col-md-6 pr-94">
            <h2>
              <span class="line">Discover</span> the information available in
              DASH and learn how it works
            </h2>
          </div>
          <div class="col-md-6">
            <VideoModal />
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container py-4">
        <div class="row mb-100">
          <div class="col-md-6 pr-94">
            <h2><span class="line">Who</span> is DASH for?</h2>
            <p class="large">
              DASH is designed for network operators who want to ensure their
              network is secure and stay on top of security news.
            </p>
          </div>
          <div class="col-md-6">
            <img
              v-lazy="'/static/landing/section3-1.svg'"
              alt="who is dash for"
              class="smaller-img"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mobile-hide section-3">
            <!-- <img
              v-lazy="'/static/landing/section3.png'"
              alt="what can you do with dash"
            /> -->
          </div>
          <div class="col-md-6">
            <h2><span class="line">What</span> can you do with DASH?</h2>
            <h4>Monitor</h4>
            <p class="large">
              Monitor suspicious traffic seen coming from your network.
            </p>
            <h4>Be promptly notified:</h4>
            <p class="large with-bullet mb-2">
              When suspicious traffic is detected.
            </p>
            <p class="large  with-bullet">
              Of potential network misconfigurations and BGP hijacks.
            </p>
            <h4>Request a personalized service</h4>
            <p class="large">
              The APNIC Security Team can assist you to get more complete
              information about the suspicious traffic seen coming from your
              network.
            </p>
            <h4>Report</h4>
            <p class="large">
              Generate a situation awareness report for your network.
            </p>
            <h4>Compare</h4>
            <p class="large">
              Compare suspicious activity coming from your organization’s
              network against your economy or sub-region.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="section login-section">
      <div class="container py-4">
        <h2>Start using DASH now and keep your users secure</h2>
        <p class="large">
          DASH can also help mitigate the impact of an infection in other
          networks.
        </p>
        <div class="button-wrapper">
          <button class="btn btn-primary" primary @click="authenticateOidc">
            Log in
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueScrollTo from 'vue-scrollto';
import VideoModal from '../components/VideoModal';
import authStore from '../store/modules/authentication';
import router from '../router';

export default {
  methods: {
    ...mapActions('authStore', ['authenticateOidc', 'authenticateOidcSilent'])
  },
  components: {
    VideoModal
  },
  mounted() {
    this.authenticateOidcSilent()
      .then(e => {
        this.intervalTimer = setInterval(() => {
          const isAuth = authStore.getters.oidcIsAuthenticated(authStore.state);

          if (isAuth) router.push('/routing-status');
        }, 1000);
      })
      .catch(err => {});
  },
  destroyed() {
    clearInterval(this.intervalTimer);
  },
  directives: {
    scrollTo: VueScrollTo
  }
};
</script>

<style lang="scss" scoped>
.landing-page {
  .section--first {
    height: calc(100vh - 50px);
    display: flex;
    position: relative;

    @media screen and (max-width: 768px) {
      height: auto;
      display: block;
    }

    .description {
      position: absolute;
      left: 5%;
      top: 50%;
      transform: translateY(-60%);
      z-index: 8;
      width: 40%;
      padding: 0;

      @media screen and (max-width: 992px) {
        width: 70%;
        left: 15%;
        padding: 0 2rem;
      }

      @media screen and (max-width: 768px) {
        width: 100%;
        left: 0;
        padding: 0 2rem;
      }

      @media screen and (max-width: 576px) {
        padding: 0 1rem;
      }

      h1 {
        font-size: 6.5vh;
      }

      h2 {
        font-size: 3vh;
        line-height: 4vh;
        margin-bottom: 2vh;
      }

      p {
        font-size: 2vh;
        line-height: 2.5vh;
        margin-bottom: 1.5vh;
      }

      button {
        font-size: 2vh;
        width: 12vw;
        height: 5vh;
      }

      .font-weight-bold {
        margin: 1rem 0;
      }
    }

    .section-1 {
      width: 100%;
      height: 100%;
      margin: 0;

      .left {
        padding: 0;
      }

      .right {
        height: 100%;
        // background-image: url(/static/landing/section1.png);
        // background-repeat: no-repeat;
        // background-position: center center;
        // background-size: auto 100%;

        padding: 0;

        @media screen and (max-width: 992px) {
          background-image: none;
          height: 0;
        }

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: left bottom;
        }
      }
    }
  }
  .section {
    padding: 142px 0;

    &--first {
      padding: 0;
      min-height: calc(100vh - 50px);
      display: flex;
      align-items: center;
      box-sizing: border-box;
      position: relative;

      .discover-more {
        position: absolute;
        bottom: 50px;
        width: 16vh;
        left: 5%;
        cursor: pointer;
        text-align: center;
        font-weight: 600;
        font-size: 2vh;

        @media screen and (max-width: 992px) {
          bottom: 20px;
          width: 100%;
          left: 0;
        }

        img {
          margin-top: 0.8rem;
          width: 5vh;
        }
      }
    }
    &:nth-child(4) {
      background: #f5f5f5;
    }

    h1 {
      margin-bottom: 3vh;
    }

    h2 {
      margin-top: 0;
      margin-bottom: 20px;
    }

    h4 {
      margin-bottom: 10px;
    }

    p {
      margin-bottom: 20px;
    }

    img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
    }

    .smaller-img {
      width: 80%;
    }

    .button-wrapper {
      margin-top: 40px;
      text-align: center;
    }

    .pr-94 {
      padding-right: 94px;
    }

    .mb-100 {
      margin-bottom: 100px;
    }

    .line {
      border-top: 3px solid #006aa4;
      border-color: #006aa4;
      padding-top: 20px;
    }

    .with-bullet {
      display: list-item;
      list-style-position: inside;
    }

    .nowrap {
      white-space: nowrap;
    }

    .feature-text {
      margin: 0 1.5rem;
      margin-bottom: 2rem;

      p {
        margin-bottom: 0.5rem;
        line-height: 1.5;
      }

      .break-line {
        @media screen and (max-width: 1400px) {
          display: none;
        }
      }
    }
  }

  .login-section {
    text-align: center;
  }

  .row {
    align-items: center;
  }

  .section-3 {
    height: 80vh;

    background-image: url(/static/landing/section3.png);
    background-repeat: no-repeat;
    background-position: left bottom;
    background-size: cover;
  }

  @media screen and (max-width: 768px) {
    .section {
      padding: 56px 0;

      .pr-94 {
        padding-right: 0;
      }

      .col-md-6:nth-child(even) {
        margin-top: 20px;
      }

      .mobile-hide {
        display: none;
      }

      .row.mb-100 {
        margin-bottom: 0;
      }
    }

    .login-section {
      text-align: left;

      .button-wrapper {
        text-align: left;
      }
    }
  }
}
</style>
